export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImE0ZjBjOGYwLTkxNzItNDcxNS05ODZmLTI0MzhmYzdkZjRhMyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.uJKlxo9+nPPqlxIk+XjvmOPxt4g3oF1RwK+++GKn3MHRmD6vc8qNFE0wz342VhLBSboaFKIk4tKQKBdu+lB+yC79IoaVFt8NZb8iwtwaOQlwDPcNPCzL33FRjThby3hLpOD6Iw==';
